/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/packages-source-foundations-accessibility-helpers--page#visually-hidden-elements)
 *
 * CSS rules that hide something from sight while still being available to screen readers.
 */

export const visuallyHidden = `
	position: absolute;
	opacity: 0;
	height: 0;
	width: 0;
	top: 0;
	left: 0;
`;
